import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import utils
import { numberWithCommas } from "../../../utils/utility";
import { calculateDateDifferenceInDays } from "../../../utils/date";

//import constants
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import { BaseButton } from "../../common/base-button/base-button";
import BaseCarousel from "../../common/base-carousel/base-carousel";
import BaseRating from "../../common/base-rating/base-rating";

//import images and icons
import { Star1 } from "iconsax-react";

//import styles
import "./hotel-item.scss";

function IntHotelItem({ hotelItem }) {
    //general variables
    const [_, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    //sessionStorage variables
    const { isHotelInternational } = JSON.parse(sessionStorage.getItem("generalInformation"));
    const { checkIn, checkOut } = JSON.parse(sessionStorage.getItem("hotelInformation"));

    

    //all dates length
    const [dateLength, setDateLength] = useState(null);
    useEffect(() => {
        setDateLength(calculateDateDifferenceInDays(checkIn, checkOut));
    }, [hotelItem]);

    //go to hotel information
    const goToHotelInformation = (hotel, action) => {
        const { id, tag } = hotel;
        const params = { hotelId: id, tag, action };
        setSearchParams(params);
        sessionStorage.setItem("selectedHotel", JSON.stringify(hotel));
    };

    //mobile functions
    const handleHotelDetails = (hotel, action) => {
        if (IS_MOBILE) {
            goToHotelInformation(hotel, action);
        }
    };

    return (
        <Grid
            className="hotel-item"
            container
            item
            xs={12}
            rowGap={1}
            justifyContent="space-between"
            onClick={() => handleHotelDetails(hotelItem, "hotel-details")}
        >
            <Grid className="hotel-item__hotel-images" container item xs={12} md={2.5} xl={2} my={1}>
                <BaseCarousel
                    imageList={hotelItem?.images}
                    dir="rtl"
                    height="136px"
                    slidesPerView={1}
                    spaceBetween={10}
                    loop={true}
                    navigation={IS_MOBILE ? false : true}
                    pagination={true}
                    paginationType="fraction"
                    grid={1}
                    thumbsGallery={false}
                    baseUrl={isHotelInternational ? "" : "https://api.atripa.ir"}
                />
            </Grid>

            <Grid className="hotel-item__details" container item xs={12} md={5} xl={6} justifyContent="space-between">
                <Grid container item xs={12} columnGap={{ xs: 1, md: 0 }} justifyContent={{ xs: "flex-start", md: "space-between" }}>
                    <Grid className="hotel-item__name" component="span" container item xs={12}>
                        {hotelItem?.type} {hotelItem?.name}
                    </Grid>
                </Grid>

                <Grid container item xs={12}>
                    <BaseRating value={hotelItem?.star} icon={Star1} emptyIcon={Star1} color="var(--golden-color)" size="20" readOnly={true} />
                </Grid>

                <Grid className="hotel-item__address" component="span" container item xs={12} display={{ xs: "none", md: "flex" }}>
                    {hotelItem?.address}
                </Grid>

                <Grid container item xs={8.5} md={12} rowGap={1.5} columnGap={1.5} display={{ xs: "none", md: "flex" }} alignItems="center">
                    {hotelItem?.amenities?.map(amenitie => {
                        return <span className="hotel-item__amenitie">{amenitie}</span>;
                    })}
                </Grid>
            </Grid>

            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "flex" } }} />

            <Grid container item xs={12} md={4.25} xl={3.5} alignItems="center">
                <Grid className="hotel-item__price" container item xs={12} justifyContent={{ xs: "space-between", md: "space-evenly" }}>
                    <Grid container item xs={5} direction="column" justifyContent="flex-start">
                        <span className="hotel-item__price-title">{t("priceStart")}:</span>
                        <span className="hotel-item__person">
                            ({dateLength} {t("nightsStay")})
                        </span>
                    </Grid>
                    <Grid container item xs={5} direction="column" justifyContent="flex-start" alignItems="flex-end">
                        <span className="hotel-item__offer-price">
                            {numberWithCommas(hotelItem?.fare?.total)}&nbsp; {t("currency")}
                        </span>
                        {hotelItem?.room_min_price?.prices?.has_off && hotelItem?.room_min_price?.prices?.total_board_price !== 0 ? (
                            <>
                                <span className="hotel-item__origin-price">
                                    {numberWithCommas(hotelItem.room_min_price.prices.total_board_price)} {t("currency")}
                                </span>
                                <span className="hotel-item__percent">
                                    <span>
                                        {Math.round(
                                            ((hotelItem.room_min_price.prices.total_board_price - hotelItem.room_min_price.prices.total_price) /
                                                hotelItem.room_min_price.prices.total_board_price) *
                                                100,
                                        )}
                                        %
                                    </span>
                                </span>
                            </>
                        ) : (
                            ""
                        )}
                    </Grid>
                </Grid>

                <Grid
                    className="hotel-item__action"
                    container
                    item
                    xs={12}
                    display={{ xs: "none", md: "flex" }}
                    justifyContent="space-evenly"
                    alignItems="flex-end"
                >
                    <Grid container item xs={5}>
                        <BaseButton
                            text={t("details")}
                            color="outline"
                            size="large"
                            radius="radius-10"
                            handleClick={() => goToHotelInformation(hotelItem, "information")}
                        />
                    </Grid>
                    <Grid container item xs={5}>
                        <BaseButton
                            color="primary"
                            text={t("select")}
                            size="large"
                            radius="radius-10"
                            handleClick={() => goToHotelInformation(hotelItem, "rooms")}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default IntHotelItem;
